import { urlSearchParamsAsObject } from '../url/search-params';

export function formDataToJSON( fd: FormData ): string {
    const result: Record<string, any> = {};

    for ( const key of fd.keys() ) {
        const values = fd.getAll( key )
            .filter( ( v: FormDataEntryValue ) => typeof v === 'string' )
            .filter( ( s: string ) => s.length > 0 );

        if ( values.length > 1 ) {
            result[ key ] = values;
        } else {
            result[ key ] = values[ 0 ];
        }
    }

    return JSON.stringify( result );
}

export function urlSearchParamsToJSON( searchParams: URLSearchParams ): string {
    return JSON.stringify( urlSearchParamsAsObject( searchParams ) );
}
